import isMotionReduced from './motion_reduce';

const BREAK_POINT = 768;

export default function topBg() {
  document.addEventListener('DOMContentLoaded', () => {
    if (isMotionReduced()) {
      return
    }

    const isSp = window.innerWidth < BREAK_POINT;
    const fadeinItems = document.querySelectorAll('.js-topBg');
    const elements = Array.prototype.slice.call(fadeinItems);
    let options = {
      rootMargin: '-30%',
      threshold: 0.0,
    };
    if (isSp) {
      options = {
        rootMargin: '-10%',
        threshold: 0.0,
      };
    }

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return
        }

        const target = entry.target;
        target.classList.remove('is-hidden');
        observer.unobserve(target);
      });
    }, options);

    elements.forEach((element) => {
      element.classList.add('is-hidden');
      observer.observe(element);
    });
  });
}

topBg();
